import { put, takeLatest, call, select } from 'redux-saga/effects';

import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import { formatError } from '../../../libs';
import categoryAPI from '../../api/category';
import { Types, Creators as CategoryCreators } from '../../reducers/category';
import { Creators as GlobalCreators } from '../../reducers/global';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function parseToJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

function* getCategory({ query, categoryLoaded = null, params = {} }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);
    const category = !isEmpty(categoryLoaded)
      ? categoryLoaded
      : yield call(categoryAPI.getSlug, query.join('/'), siteId);

    if (!category || isEmpty(category)) {
      throw `Página ${query.join('/')} não encontrada`;
    }

    const searchQuery = {
      sortBy: app.getIn(['config', 'components', 'Category', 'sortBy']),
      filter: {
        categoria: [{ id: 'categoria', value: category.id, fixed: true }],
      },
      limit: app.getIn(['config', 'components', 'Category', 'pagination', 'limit']),
      offset: app.getIn(['config', 'components', 'Category', 'pagination', 'offset']),
      ...params,
    };

    delete searchQuery.filtro;

    if (params.filtro) {
      const parsedFilter = parseToJson(params.filtro);
      const filter = !isArray(parsedFilter) ? [parsedFilter] : parsedFilter;

      filter.forEach((item) => {
        searchQuery.filter[item.id] = [...(searchQuery.filter[item.id] || []), ...[item]].filter((obj) => !!obj);
      });
    }

    const queryFinal = {
      ...searchQuery,
      filter: [],
    };

    map(searchQuery.filter, (item) => {
      if (isArray(item)) {
        item.map((subItem) => queryFinal.filter.push(JSON.stringify(subItem)));
      } else {
        queryFinal.filter.push(JSON.stringify(item));
      }
    });

    queryFinal.filter = queryFinal.filter.join(',').toString();

    const {
      aggregations = [],
      _result = {},
      products = [],
    } = yield call(categoryAPI.getProducts, queryFinal, siteId, token);

    const sidebar = [
      { ...aggregations.find((item) => item.id === 'categoria'), multiple: false },
      {
        ...aggregations.find((item) => item.id === 'segmentoPrincipal'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: true,
      },
      {
        ...aggregations.find((item) => item.id === 'marcaProduto'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: true,
      },
      {
        ...aggregations.find((item) => item.id === 'tabelaPreco'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: true,
      },
      {
        ...aggregations.find((item) => item.id === 'definicao'),
        multiple: true,
        expansionShowItems: app.getIn(['config', 'components', 'Category', 'expansionShowItems']),
        visible: true,
      },
    ];

    const data = {
      id: category.id,
      url: category.url || null,
      seo: category.seo || {},
      content: category.content || null,
    };

    const breadcrumbs = category.breadcrumb.map(({ name, url }) => ({ title: name, name, url }));
    const filters = {
      sortBy: app.getIn(['config', 'components', 'Category', 'sortBy']),
      sortByOptions: app.getIn(['config', 'components', 'Category', 'sortByOptions']).filter((item) => item.active),
      sidebar,
    };

    yield put(
      CategoryCreators.getCategorySuccess({
        data,
        breadcrumbs,
        filters,
        searchQuery,
        products: products.map((item) => ({ ...item, loaded: true })),
        totalProducts: products.length > 0 ? _result.total : products.length,
      })
    );
  } catch (error) {
    yield put(GlobalCreators.errorApp(formatError(error)));
    yield put(CategoryCreators.getCategoryError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_CATEGORY_REQUEST, getCategory);
}
